/**
 * There are three main types of movement paths for a widget
 *
 * Fixed   - Widget does not move
 * Line    - Widget moves along a straight line defined by an origin and a direction
 * Circle  - Widget moves along a circular path defined by a center, a normal, and a radius
 */
export var PathType;
(function (PathType) {
    PathType[PathType["Fixed"] = 0] = "Fixed";
    PathType[PathType["Line"] = 1] = "Line";
    PathType[PathType["Circle"] = 2] = "Circle";
})(PathType || (PathType = {}));
